import { Ui as ui } from './ui/ui';
import { OrderBy as orderBy } from './orderby.enum';
import { Workspace as workSpace } from './workspace.enum';
import { ToolCode as toolCode } from './tool-code.enum';
import { UrlParameter as urlParameter } from './url-parameter.enum';
import { Environment as environment} from "./environment.enum";
import { HttpStatus as httpStatus } from './http-status.enum';

namespace Enums {
  export import Ui = ui;
  export import OrderBy = orderBy;
  export import Workspace = workSpace;
  export import ToolCode = toolCode;
  export import UrlParameter = urlParameter;
  export import Environment = environment;
  export import HttpStatus = httpStatus;
}
export default Enums;
